export var STATUS_UPLOAD_FAILURE = 'fileupload-failure';
export var STATUS_UPLOAD_PROCESSING = 'processing';
export var STATUS_FILETYPE_FAILURE = 'filetype-failure';
export var STATUS_UPLOAD_SUCCESS = 'success';

// Mirrors DigitalAbstractFileRejected::REASON_FILE_SIZE_EXCEEDED, which the API returns as `errorCode`
export var FILE_ERROR_CODE_FILE_SIZE_EXCEEDED = 'file-size-exceeded';
export var FILE_STATUS = {
  STATUS_UPLOAD_FAILURE: STATUS_UPLOAD_FAILURE,
  STATUS_UPLOAD_PROCESSING: STATUS_UPLOAD_PROCESSING,
  STATUS_FILETYPE_FAILURE: STATUS_FILETYPE_FAILURE,
  STATUS_UPLOAD_SUCCESS: STATUS_UPLOAD_SUCCESS
};